import React, {useEffect, useState} from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from "axios";



const IpadGameover = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { casoClinico, userId, gameId } = location.state || {};
    const [playerField, setPlayerField] = useState('');



    useEffect(() => {
        // Determina quale campo aggiornare per il giocatore
        const fetchPlayerField = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/get-players`, { params: { gameId } });
                const { fkidplayer1, fkidplayer2 } = response.data;

                // Determina se il giocatore corrente è player1 o player2
                if (userId === fkidplayer1) {
                    setPlayerField('monitor_player1');
                } else if (userId === fkidplayer2) {
                    setPlayerField('monitor_player2');
                } else {
                    console.error("Errore: userId non corrisponde a nessun giocatore.");
                }
            } catch (error) {
                console.error("Errore nel recupero delle informazioni dei giocatori:", error);
            }
        };

        fetchPlayerField();
    }, [gameId, userId]);

    // Aggiorna lo stato del giocatore nel database
    const updatePlayerState = async (nextState) => {
        if (!playerField) return;

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/update-monitor-state-bis`, {
                gameId,
                playerField,
                state: nextState
            });
            console.log(`Stato aggiornato per ${playerField}: ${nextState}`);
        } catch (error) {
            console.error("Errore nell'aggiornamento dello stato del monitor:", error);
        }
    };


    useEffect(() => {
        if (playerField) {
            updatePlayerState('gameover');
        }
    }, [playerField, gameId]);




    // OLD:Invia una richiesta al backend per aggiornare lo stato del monitor
    useEffect(() => {

        axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/update-monitor-state`, { gameId, monitor: 'gameover' })
            .then((response) => {
                console.log("Stato del monitor aggiornato:", response.data);
            })
            .catch((error) => {
                console.error("Errore nell'aggiornamento dello stato del monitor:", error);
            });
    }, [casoClinico, gameId]);




    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/ipad');
        }, 20000); // 20 secondi

        return () => clearTimeout(timer); // Pulisce il timer se il componente si smonta
    }, [navigate]);

    return (
        <div
            className="ipad_gameover flex flex-col w-full h-full  items-center justify-center relative bg-fixed overflow-hidden">

           {/* <div className="text-center absolute top-[298px] left-[450px]" style={{border: '0px solid red'}}>
                <img src={avatarMap[avatar]} alt="Avatar" className="w-[120px] h-auto rounded-full mx-auto mb-4"/>
                <p className="text-2xl font-bold bg-orange text-white px-2 rounded-t-md">{nickname}</p>
                <p className="text-2xl font-bold bg-orange text-white px-4 py-1 rounded-b-md" >Punteggio: {punteggio}</p>
            </div>*/}
        </div>
    );
};

export default IpadGameover;
